<template lang="pug">
    .msg
        .left(v-loading="loading")
            .cards(v-if="items && items.length")
                el-card.card(v-for="item in items" :key="item.id" @click.native="changeDetail(item)")
                    el-badge.badge(value="new" :hidden="item.checked") {{item.message}}
                    p.date {{new Date(item.created_at * 1000).toLocaleString()}}
            el-pagination.tc(v-if="items && items.length" background layout="prev, pager, next" :page-size="size" :total="count" :current-page="page"  @current-change="pageChange" :pager-count="5" small)
            .nomsg(v-else)
                i.icon.icon-nomsg
                p 暂时没有消息

        .right.box.msg-content
            dl(v-if="detail")
                dt 系统消息
                dd.tc {{new Date(detail.created_at * 1000).toLocaleString()}}
                dd.tc {{detail.message}}
            .nomsg(v-else)
                i.icon.icon-nomsg

</template>

<script>
import storeMixin from '../store/mixin';

export default {
    name: 'Msg',
    mixins: [storeMixin],
    data() {
        return {
            items: null,
            loading: false,
            size: 5,
            count: 0,
            page: 1,
            detail: null,
        };
    },
    created() {
        console.log('created');
        this.getMsg();
    },
    methods: {
        async getMsg() {
            const { data } = await this.REQUEST({
                url: `v2/notification/list?limit=${this.size}&page=${this.page}`,
            });
            this.items = data.items;
            this.count = data.count;
        },
        pageChange(n) {
            this.page = n;
            this.getMsg();
        },
        async changeDetail(item) {
            this.detail = item;
            if (this.detail.checked) return;

            this.detail.checked = true;
            await this.REQUEST({
                url: 'v2/notification/check',
                method: 'POST',
                body: JSON.stringify({
                    id: item.id,
                }),
            });
            this['USER/SET_STATE']({
                key: 'MSG',
                value: this.USER.MSG >= 1 ? this.USER.MSG - 1 : 0,
            });
        },
    },
};
</script>

<style lang="stylus" scoped>
*
    padding 0
.msg
    display flex
    width 100%
.left
    margin 0 20px 0 0
    width 300px
    flex-shrink 0
.right
    flex-grow 1
.msg-content
    text-align center
    padding 50px
    dt
        font-size 32px
        margin 0 0 20px 0
    dd
        text-align left
        &.tc
            text-align center
        &:first-of-type
            margin 0 0 20px 0
.cards
    min-height calc(100% - 50px)
.card
    margin-bottom 10px
    cursor pointer
    background #1e1f25
.badge
    display block
    margin-right 30px
.date
    font-size .8em
    color #aaa
.nomsg
    width 100%
    height 100%
    display flex
    flex-direction column
    align-items center
    justify-content center
    & > *
        margin 10px 0
</style>
